import { render, staticRenderFns } from "./product-gallery-recently-viewed.vue?vue&type=template&id=43a20862&"
import script from "./product-gallery-recently-viewed.vue?vue&type=script&lang=js&"
export * from "./product-gallery-recently-viewed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43a20862')) {
      api.createRecord('43a20862', component.options)
    } else {
      api.reload('43a20862', component.options)
    }
    module.hot.accept("./product-gallery-recently-viewed.vue?vue&type=template&id=43a20862&", function () {
      api.rerender('43a20862', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/product-gallery-recently-viewed/product-gallery-recently-viewed.vue"
export default component.exports